import React, {useState} from 'react';
import cl from "../BaseSimplePage/BaseSimpleItemBrowserHeader.module.css";
import {Button, Tooltip} from "@mui/material";
import RefreshIcon from "../../components/Icons/RefreshIcon";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import 'dayjs/locale/ru';

const LOCALE_TEXT = {
    fieldDayPlaceholder: (params) => 'ДД',
    fieldMonthPlaceholder: (params) => params.contentType === 'digit' ? 'ММ' : params.format,
    fieldYearPlaceholder: (params) => 'ГГГГ',
}

const SurveysSummaryBrowserHeader = ({
                                           totalItemCount,
                                           onFilterEdit,
                                           renderExtraContent,
                                           dateFromText,
                                           setDateFromText,
                                           dateTillText,
                                           setDateTillText,
                                       }) => {

    const [dateFromValue, setDateFromValue] = useState(dateTextToDayJs(dateFromText))
    const [dateTillValue, setDateTillValue] = useState(dateTextToDayJs(dateTillText))

    function renderDatePicker(label, dateValue, setDateValue, setDateText) {
        return <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="ru"
            localeText={LOCALE_TEXT}
        >
            <DatePicker
                value={dateValue}
                label={label}
                slotProps={{
                    field: {
                        clearable: true,
                        size: "small"
                    },
                }}
                disableHighlightToday
                onChange={(v,c) => {
                    //console.log("onChange", "v=", v, "c=", c);
                    //console.log("date=", v?.format('YYYY-MM-DD') ?? "null")
                    setDateValue(v);
                    setDateText(c.validationError ? "error" : dayJsToDateText(v))
                    onFilterEdit();
                }}
                sx={{backgroundColor: 'white'}}
            />
        </LocalizationProvider>
    }

    return (
        <div className={cl.main}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                /*backgroundColor: "#0000ff40",*/
                marginBottom: "10px",
                flexWrap: "wrap",
                rowGap: "7px",
                columnGap: "12px",
            }}>
                <p style={{
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#222',
                    textWrap: "nowrap",
                }}>
                    {totalItemCount >= 0 && <>Найдено: {totalItemCount}</>}
                </p>
                <div style={{display: "flex", gap: "10px", /*backgroundColor: "#00ff0040"*/}}>
                    <Tooltip title={<div className={cl.tip}>Обновить</div>}>
                        <Button
                            variant="outlined"
                            size="medium"
                            sx={{width: "40px", minWidth: "40px"}}
                            onClick={() => onFilterEdit(true)}
                        >
                            <RefreshIcon fgColor={"rgba(0, 0, 0, 0.54)"}/>
                        </Button>
                    </Tooltip>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                {renderDatePicker("Даты с", dateFromValue, setDateFromValue, setDateFromText)}
                {renderDatePicker("Даты по", dateTillValue, setDateTillValue, setDateTillText)}
            </div>

            {renderExtraContent && renderExtraContent()}
        </div>
    );
};

function dateTextToDayJs(dateText) {
    return dateText && dateText !== "error" ? dayjs(dateText) : null;
}

function dayJsToDateText(value) {
    return value ? value?.format('YYYY-MM-DD') : "";
}

export default SurveysSummaryBrowserHeader;